import { HttpResponse } from 'lib/http/http.model';
import httpService from 'lib/http/http.service';
import DeviceApiEndpoint from './device.endpoint';

const DeviceApi = {
    init: (): HttpResponse<string> =>
        httpService.client.post(DeviceApiEndpoint.INIT, undefined, {
            headers: {
                'x-app-location': httpService.location?.join(','),
            },
        }),
};

type DeviceApi = typeof DeviceApi;

export default DeviceApi;
